import Home from "./pages/Home/Home.svelte";
import NotFound from "./pages/NotFound/NotFound.svelte";
export default {
    "/": Home,
    // The catch-all route must always be last
    "*": NotFound,
};
